import React, {useState, useEffect, useRef} from 'react';
import styles from '../Patient.module.css';
import { useSelector, useDispatch } from 'react-redux';
import PatientDetailDropdownCard from '../../../components/PatientDetailDropdownCard';
import FilterPatientView from '../FilterPatientDetail';
import CareProgramDetails from '../CardDetails/CareProgramDetails';
import useAxios from '../../../services/AxiosConfig';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setEnrollmentState, setFormValue } from '../../patient-enrollment/PatientEnrollmentSlice';
import { formatDateString } from '../../../utils/dateUtils';

const CareProgramView= () => {

    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userId = useSelector((state)=>state.userInfo.id);
    const {taskEnrollmentId, carePrograms} = useSelector((state)=>state.patient);
    const {dateOrder, searchText} = useSelector((state)=>state.patientDetailFilter);
    const dateFormat = useSelector((state) => state.userInfo.dateFormat);
    const [allDevices, setAllDevices] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const programRefs = useRef([]);
    const [openedProgramId, setOpenedProgramId] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const deviceResponse = await axios.get(`device/group/${userId}`);
                const deviceData = deviceResponse.data.data;
                let tempDevices = [];
                let uniqueDevices = new Set();
                if (deviceData.length >= 1) {
                    deviceData.forEach((device)=>{
                        if (!uniqueDevices.has(device.deviceId)) {
                            tempDevices.push(device);
                            uniqueDevices.add(device.deviceId);
                        }
                    })
                }
                setAllDevices(tempDevices);
            } catch (error) {
                console.error("Failed to fetch data:", error);
            }
        }
        fetchData();
    }, []);

    const calculateNewProgram = (startDate) => {
        const start = new Date(startDate);
        const end = new Date();
        return start >= end;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return formatDateString(date.toISOString(), dateFormat);
    };
    
    const sortedCarePrograms = [...carePrograms].filter(item => (
        item.name.toLowerCase().includes(searchText.toLowerCase())
    )).sort((a, b) => {
        const startDateA = new Date(a.enrollment.startDate);
        const startDateB = new Date(b.enrollment.startDate);
        if (dateOrder==="ascending") {
            return startDateA - startDateB;
        } else {
            return startDateB - startDateA;
        }
    });

    useEffect(() => {
        if (sortedCarePrograms && programRefs.current) {
          const programIndex = sortedCarePrograms.findIndex(program => program.enrollmentId === taskEnrollmentId);
          if (programIndex !== -1) {
            const element = programRefs.current[programIndex];
            if (element) {
              element.scrollIntoView({ behavior: 'smooth'});
              setOpenedProgramId(taskEnrollmentId);
            }
          }
        }
      }, [taskEnrollmentId, carePrograms]);

    const initModalities = (devicesList) => {
        const modalitiesList = [];
        devicesList.forEach((device)=>{
            let foundDevice = allDevices.find(item => item.deviceId === device.deviceId)
            if (foundDevice) {
                foundDevice.modalities.forEach((mod)=>{
                    modalitiesList.push({id: mod.modalityId, name:mod.modalityName})
                })
            }
        })
        return modalitiesList;
    };

    const handleEditProgram = (program) => {
        dispatch(setEnrollmentState(program));
        dispatch(setFormValue({key:"updating", value:true}));
        dispatch(setFormValue({key:"updatingProgramOptions", value:carePrograms.filter((item) => !item.enrollment.dischargeDate)}));
        navigate('/enroll-patient');
    };

    return (
        <div className={styles.ViewContainer}>
            <FilterPatientView isSearch={true} isDate={true}/>
            <div className={styles.PatientViewScrollContainer}>
                
            {sortedCarePrograms.map((program, index) => {
                let dateSubtitle = `${formatDate(program.enrollment.startDate)} - ${formatDate(program.enrollment.endDate)}`
                let label = {
                    name:"In Program",
                    color: "#1F5C29"
                };
                if (program.enrollment.dischargeDate) {
                    label = {
                        name:"Discharged",
                        color: "#686869"
                    }
                } else if (calculateNewProgram(program.enrollment.startDate)) {
                    label = {
                        name:"New Program",
                        color: "#946705"
                    }
                }
                let allModalities = initModalities(program.devices);
                return (
                    <div key={index} ref={el => programRefs.current[index] = el}>
                        <PatientDetailDropdownCard 
                            title={program.name} 
                            subtitle2={dateSubtitle}
                            label={label}
                            cardInfo={<CareProgramDetails data={program} allModalities={allModalities}/>}
                            rightComponent={
                                !program.enrollment.dischargeDate && 
                                <div 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditProgram(program);
                                    }}
                                    style={{ 
                                        cursor: 'pointer',
                                        color: '#006969'
                                    }}
                                >
                                    <FontAwesomeIcon icon="fa-solid fa-pencil" />
                                </div>
                            }
                            headerBackground={openedProgramId === program.enrollmentId ? "rgba(203, 243, 210, 0.40)" : "white"}
                        />
                    </div>
                )
            })
            }
            {sortedCarePrograms.length === 0 &&
                <div className={styles.emptyView}>
                    Patient has not been enrolled in a care program
                </div>
            }
            </div>
        </div>
    );
}

export default CareProgramView;